<ion-header *ngIf="shouldDisplaySearchField">
  <ion-searchbar
    (ionChange)="onSearchTermChange($event)"
    (keyup.enter)="onEnterPressed()"
    debounce="300"
    placeholder="{{ 'm/task-process/gifs/search' | translate }}"></ion-searchbar>
</ion-header>

<ion-content>
  <ion-list>
    <div
      *ngFor="let tag of displayedTags"
      (click)="selectTag(tag)"
      [class]="'value-and-icon ' + (tag.isCategory ? 'category' : '')">
      <div class="value alc-ellipsis">{{ tag.name }}</div>
      <ion-icon *ngIf="!hideSelection && !tag.isCategory && group.selectedTagId === tag.id" name="checkmark"></ion-icon>
    </div>
  </ion-list>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="onInfiniteScroll()">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
